import React from "react";
import ReactDOM from "react-dom";
import { getElementsProperty } from "../helpers/getElementsProperty";
import StockGraph from './components/StockGraph/index'

/**
 * @param {*} className - class name which in will be initialized canvas chart
 */
export const initGraphs = className => {
  getElementsProperty(className, (property, element) => {
    if(property.type === 'marketStockGraph') {
      // idNumber is to prevent id duplication where is more than one chart on page
      property.idNumber = Math.floor(Math.random() * 1000000);
      ReactDOM.render(<StockGraph {...property} />, element);
    }
  });
};
